import { render } from "./Expansion.vue?vue&type=template&id=0cb6f757"
import script from "./Expansion.vue?vue&type=script&lang=js"
export * from "./Expansion.vue?vue&type=script&lang=js"

import "./Expansion.vue?vue&type=style&index=0&id=0cb6f757&lang=scss"
script.render = render

export default script